export const getNodeInnerHeight = (node: HTMLElement | null): number =>
  node
    ? node.getBoundingClientRect().height -
      (Number(node.style.paddingTop) || 0) -
      (Number(node.style.paddingBottom) || 0)
    : 0;
